module.exports = __webpack_public_path__ + "static/media/2.f3d5bba4.svg";